import { SelectItemProps, formatDate } from '@ui/src';
import { CustomerStatus, CustomerProps } from '../../../common/types';

import cn from '../styles.module.css';

const formatCorporateCustomersList = (
  list: CustomerProps[],
  countries?: SelectItemProps[],
  incorporationDates?: SelectItemProps[],
): CustomerProps[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let statusClassName;
    let status;

    if (result.status === CustomerStatus.ACTIVE) {
      status = 'Active';
      statusClassName = cn.corporateCustomerActive;
    } else if (result.status === CustomerStatus.CLOSED) {
      status = 'Closed';
      statusClassName = cn.corporateCustomerRestricted;
    } else if (result.status === CustomerStatus.SUSPENDED) {
      status = 'Suspended';
      statusClassName = cn.corporateCustomerRestricted;
    } else {
      status = 'Disabled';
      statusClassName = cn.corporateCustomerDisabled;
    }

    const dateOfIncorporation = incorporationDates?.find(
      (incorporationDate) =>
        incorporationDate.value === result.dateOfIncorporation,
    );

    const render: Record<string, React.JSX.Element> = {
      dateOfIncorporation: (
        <div>
          {dateOfIncorporation?.name || formatDate(result.dateOfIncorporation)}
        </div>
      ),
      ids: <div className={cn.organizationWrapperId}>{result?.ids}</div>,
      countryOfIncorporationId: (
        <div>
          {
            countries?.find(
              (country) => country.value === result.countryOfIncorporationId,
            )?.name
          }
        </div>
      ),
      status: (
        <div
          className={`${statusClassName} ${cn.corporateCustomerStatus} ${
            result.status === CustomerStatus.ACTIVE ? cn.activeStatus : ''
          } ${result.status === CustomerStatus.CLOSED ? cn.closedStatus : ''}`}
        >
          {status}
        </div>
      ),
      type: <div>{result.type.toUpperCase()}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCorporateCustomersList;
